import { Component, Inject } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';

import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { DialogData } from '../../negotiations/negotiations-details/negotiations-details.component';

@Component({
    selector: 'app-negotiation-details-dialog',
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule],
    templateUrl: './negotiation-details-dialog.component.html',
    styleUrls: ['./negotiation-details-dialog.component.css']
})
export class NegotiationDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NegotiationDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close( {confirm: false});
  }

}
